import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CognitoService, IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { setSelectedOrganization } from 'src/app/state/actions/selectedOrganization.action';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  public userInfo: IUserInfoCognito | null = null;
  organizations: string[] = [];
  openEmpresaOptions: boolean = false;
  selectedEmpresa: string | null = null;
  noEmpresas = false;

  userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);
  private _selectedOrganization$ = this.store.select(selectSelectedOrganization);


  constructor(
    private router: Router,
    // private _sessionService: SessionService,
    // private _storeService: StoreService,
    private store: Store
  ) {
    this.userInfo$.subscribe((userInfo: IUserInfoCognito) => {
      if(userInfo && userInfo.organizations) {
        this.organizations = userInfo.organizations;
        this.noEmpresas = userInfo.organizations.length == 0;
      }

      if (!this.organizations || this.organizations.length == 0) {
        this.noEmpresas = true;
      }
    })

    //Cambiar por NGRX
    this._selectedOrganization$.subscribe((org: string) => {
      this.selectedEmpresa = org;
    })

    //Cambiar por NGRX
    // let selectedOrg = this._sessionService.getOrganization();
    // this._storeService.setSelectedOrg(selectedOrg);
    }

  ngOnInit(): void {
  }

  toggleEmpresaOptions() {
    this.openEmpresaOptions = !this.openEmpresaOptions;
  }

  redirectToPage(organizations: string[]){
    // if (!organizations) return;
    if (!organizations || organizations.length == 0) {
      this.noEmpresas = true;
      this.router.navigate(['/onboarding']);
    } else {
      this.router.navigate(['/landing-general']);
    }
  }

  onSelectedEmpresa(event: string) {
    this.toggleEmpresaOptions()
    this.store.dispatch(setSelectedOrganization({ selectedOrganization: event }));
    this.router.navigate(['/landing-empresa']);
  }

  onClickOnboarding(){
    this.router.navigate(['/onboarding'])
  }
}
